<!--<app-nav-menu></app-nav-menu>
<div class="container">
  <router-outlet>
    <app-spinner></app-spinner>
  </router-outlet>
</div>-->
<router-outlet>
  <app-spinner></app-spinner>
</router-outlet>
